var map = {
	"./01.jpg": 228,
	"./02.jpg": 229,
	"./03.jpg": 230,
	"./04.jpg": 231,
	"./05.jpg": 232,
	"./06.jpg": 233,
	"./07.jpg": 234,
	"./08.jpg": 235,
	"./09.jpg": 236
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 227;